<template>
  <div ref="pdfTemple" class="app-container">
    <div ref="pdfTempForm">
      <!-- 入库单基本信息 -->
      <BjDivider>
        {{ $t('BusinessPurchaseOrder2.detailTitle') }}
        <template #right>
          <el-button type="primary" @click="exportPage">{{ $t('printText') }}</el-button>
          <el-button type="primary" @click="showLog">{{ $t('BusinessPurchaseApplyDetail.operationLog') }}</el-button>
          <!-- 日志 -->
          <!-- <BjLogButton type="order" :default-query="{
            recordId: $route.query.id,
          }" no-permission api="purchaseApi" /> -->
          <el-button @click="handleClose">{{ $t('backText') }}</el-button>
        </template>
      </BjDivider>
      <div class="bj-row mt20">
        <div class="bj-col bj-col-6">
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder3.id') }}</div>
            <div class="bj-form-item-value">{{ data.code }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder3.Status') }}</div>
            <div class="bj-form-item-value">{{ data.status }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('InternalSalesOrderDetails.Comments') }}</div>
            <!--          <div class="bj-form-item-value">{{ customerRemarks }}</div>-->
            <span class="remark-actions">
              <span class="link" v-permission:BusinessPurchaseOrderCsgAdminIndexRemarks @click="openEdit">{{ $t('InternalSalesOrderDetails.Modify') }}</span>
              <span v-if="storeRemarksHistory.length" class="link history-link" v-permission:BusinessPurchaseOrderCsgAdminIndexRemarks @click="showHistory">
                <i class="el-icon-time"></i>
                <span>{{ $t('InternalSalesOrderDetails.History') }} ({{ storeRemarksHistory.length }})</span>
              </span>
            </span>
          </div>
          <div class="bj-form-item">
            <BjInput type="textarea" :rows="3" v-model="customerRemarks" disabled />
          </div>
        </div>
        <div class="bj-col bj-col-6" style="border-left: none">
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder3.Date') }}</div>
            <div class="bj-form-item-value">{{ data.creationDate | timeFilters }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder3.Item') }}</div>
            <div class="bj-form-item-value">{{ data.purchaseOrderGoods && data.purchaseOrderGoods.length }}</div>
          </div>
        </div>
        <div class="bj-col bj-col-6 no-rb">
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.Unit') }}</div>
            <div class="bj-form-item-value">{{ data.shippingMethod }}</div>
          </div>
          <template v-if="data.shippingMethod === 'Container'">
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.form.containerId') }}</div>
              <div class="bj-form-item-value">{{ data.containerId }}</div>
            </div>
  <!--          <div class="bj-form-item">-->
  <!--            <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.form.containerLength') }}</div>-->
  <!--            <div class="bj-form-item-value">{{ data.containerLength }}</div>-->
  <!--          </div>-->
  <!--          <div class="bj-form-item">-->
  <!--            <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.dropOffMethod') }}</div>-->
  <!--            <div class="bj-form-item-value">{{ data.dropOffMethod }}</div>-->
  <!--          </div>-->
          </template>
          <template v-if="data.shippingMethod !== 'Container'">
            <div v-if="data.shippingMethod === 'Pallet'" class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder3.PalletQty') }}</div>
              <div class="bj-form-item-value">{{ data.palletQty }}</div>
            </div>
            <div v-if="data.shippingMethod === 'Carton'" class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder3.cartonQty') }}</div>
              <div class="bj-form-item-value">{{ data.containerQty }}</div>
            </div>
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.form.thirdCode') }}</div>
              <div class="bj-form-item-value">{{ data.thirdCode }}</div>
            </div>
          </template>
  <!--        <div class="bj-form-item">-->
  <!--          <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.receiveDate') }}</div>-->
  <!--          <div class="bj-form-item-value">{{ data.receiveDate | timeFilters }}</div>-->
  <!--        </div>-->
        </div>
        <div class="bj-col bj-col-6" style="border-left: none">
          <template v-if="data.shippingMethod === 'Container'">
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.form.containerLength') }}</div>
              <div class="bj-form-item-value">{{ data.containerLength }}</div>
            </div>
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.dropOffMethod') }}</div>
              <div class="bj-form-item-value">{{ data.dropOffMethod }}</div>
            </div>
          </template>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.receiveDate') }}</div>
            <div class="bj-form-item-value">{{ data.receiveDate | timeFilters }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 商品信息 -->
    <BjDivider> {{ $t('BusinessPurchaseComponentsPur.information') }}
      <template slot="right">
        <div v-if="!$store.getters.cusId&&data.hjPullTime" style="font-size:12px;font-weight: 600;color:#666;margin-right: 10px;">{{ $t('BusinessPurchaseComponentsPur.time') }} : {{ data.hjPullTime | timeFilters }}</div>
        <el-button v-if="!$store.getters.cusId&&$route.query.status == 'open'" type="primary" class="main-btn" @click="onBatchconfirmation">{{ $t('Batchconfirmation') }}</el-button>
        <el-button v-if="!$store.getters.cusId" type="primary" class="main-btn" @click="onDownload">{{ $t('downloadText') }}</el-button>
        <el-button v-if="!$store.getters.cusId" type="primary" @click="getPONo">{{ $t('BusinessPurchaseComponentsPur.getPONo') }}</el-button>
        <el-button v-if="!$store.getters.cusId && $route.query.status === 'open'" :loading="fixingRecvQty" type="primary" @click="fixRecvQty">{{ $t('BusinessPurchaseComponentsPur.fixRecvQty') }}</el-button>
        <el-button type="primary" @click="exportList">{{ $t('printText') }}</el-button>
      </template>
    </BjDivider>
    <el-table v-if="!$store.getters.cusId" :data="data.purchaseOrderGoods" border script @selection-change="handleSelectionChange">
      <el-table-column :label="$t('table.countText')" type="index" align="center" :min-width="60" />
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column label="SKU" prop="skuCode" align="center"></el-table-column>
      <el-table-column :label="$t('BusinessPurchaseOrder3.Product')" prop="skuName" align="center"></el-table-column>
      <el-table-column :label="$t('BusinessPurchaseOrder3.ExpectedQty')" prop="planQty" align="center" width="120"></el-table-column>
      <el-table-column :label="$t('BusinessPurchaseOrder3.Received1')" align="center">
        <el-table-column prop="pendingQty" :label="$t('BusinessPurchaseOrder3.PendingQty')" align="center"></el-table-column>
        <el-table-column prop="stockedQty" :label="$t('BusinessPurchaseOrder3.StockedQty')" align="center"></el-table-column>
      </el-table-column>
      <el-table-column :label="$t('BarcodeConfiguration.Barcode')" prop="barCode" align="center"></el-table-column>
      <el-table-column :label="$t('BusinessPurchaseOrder3.Expiry')" prop="expiryDate" align="center">
        <template slot-scope="{ row }">{{ row.expiryDate | timeFilters }}</template>
      </el-table-column>
      <el-table-column :label="$t('goodsSku.detail.itemPerCarton')" prop="qty" align="center" width="120"></el-table-column>
      <el-table-column :label="$t('BusinessPurchaseOrder3.Batch')" prop="batchCode" align="center" width="120"></el-table-column>
      <el-table-column :label="$t('goodsPage.Serial')" prop="needSerialNo" align="center" width="80">
        <template slot-scope="{ row }">
          <span>{{ row.needSerialNo === 1 ? $t('yesText') : $t('noText') }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('BusinessPurchaseOrder3.Downloadstatus')" prop="isDownloadBarcode" align="center" width="120">
        <template slot-scope="{ row }">
          <span>{{ row.isDownloadBarcode === 1 ? $t('yesText') : $t('noText') }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('BusinessPurchaseOrder3.IsChecked')" prop="checkStatus" align="center" width="120">
        <template slot-scope="{ row }">
          <span>{{ row.checkStatus === 0 ? $t('BusinessPurchaseOrder3.Not') : row.checkStatus === 1 ? $t('BusinessPurchaseOrder3.pass') : $t('BusinessPurchaseOrder3.Fail') }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('BusinessPurchaseOrder3.IsConfirm')" prop="checkStatus" align="center" width="120">
        <template slot-scope="{ row }">
          <span>{{ row.isConfirm === 1 ? $t('ConfirmedText') : $t('UnconfirmedText') }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.operationText')" align="center" width="120">
        <template slot-scope="{ row }">
          <el-button type="text" v-if="$route.query.status == 'open'" :disabled="!!row.isConfirm" class="delete-btn" @click="onConfirm(row)">{{ $t('okText') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-table v-else :data="data.purchaseOrderGoods" border script @selection-change="handleSelectionChange">
      <el-table-column :label="$t('table.countText')" type="index" align="center" :min-width="60" />
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column label="SKU" prop="standardSkuCode" align="center"></el-table-column>
      <el-table-column :label="$t('BusinessPurchaseOrder2.form.skuName')" prop="skuName" align="center"></el-table-column>
      <el-table-column :label="$t('BusinessPurchaseOrder3.ExpectedQty')" prop="planQty" align="center" width="100"></el-table-column>
      <el-table-column :label="$t('BusinessPurchaseOrder3.Received1')" align="center">
        <el-table-column prop="pendingQty" :label="$t('BusinessPurchaseOrder3.PendingQty')" align="center"></el-table-column>
        <el-table-column prop="stockedQty" :label="$t('BusinessPurchaseOrder3.StockedQty')" align="center"></el-table-column>
      </el-table-column>
      <el-table-column :label="$t('BusinessPurchaseOrder2.form.batchCode')" prop="batchCode" align="center"></el-table-column>
      <el-table-column :label="$t('goodsPage.Serial')" prop="needSerialNo" align="center" width="80">
        <template slot-scope="{ row }">
          <span>{{ row.needSerialNo === 1 ? $t('yesText') : $t('noText') }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('BusinessPurchaseOrder2.form.expiryDate')" prop="expiryDate" width="120" align="center">
        <template slot-scope="{ row }">{{ row.expiryDate | timeFilters }}</template>
      </el-table-column>
      <el-table-column :label="$t('BusinessPurchaseDetailPage.table.length')" prop="length" align="center" width="150"><template v-slot="{ row }">{{ row.length }} cm</template></el-table-column>
      <el-table-column :label="$t('BusinessPurchaseDetailPage.table.width')" prop="width" align="center" width="150"><template v-slot="{ row }">{{ row.width }} cm</template></el-table-column>
      <el-table-column :label="$t('BusinessPurchaseDetailPage.table.high')" prop="height" align="center" width="150"><template v-slot="{ row }">{{ row.height }} cm</template></el-table-column>
      <el-table-column :label="$t('BusinessPurchaseDetailPage.table.Volume')" prop="volume" align="center" width="170">
        <template v-slot="{ row }">{{ (row.width * row.height * row.length / 1000000).toFixed(9) }} m³</template>
      </el-table-column>
      <el-table-column :label="$t('BusinessPurchaseDetailPage.table.Weight')" prop="weight" align="center" width="150"><template v-slot="{ row }">{{ row.weight }} kg</template></el-table-column>
    </el-table>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('InternalSalesOrderDetails.Modify')"
      :visible.sync="isEdit"
      :append-to-body="true"
      @close="close"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item :label="$t('BusinessPurchaseOrder3.warehouseReceiptRemarks')" prop="customerRemarks">
          <BjInput
            v-model="form.customerRemarks"
            :placeholder="$t('inputText')"
            type="textarea"
            maxlength="9999"
            show-word-limit
            clearable
            autosize
            rows="5"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="editRemarks">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
    <el-drawer
      :title="$t('InternalSalesOrderDetails.CommentsHistory')"
      :visible.sync="historyVisible"
      direction="rtl"
      size="660px"
      :append-to-body="true"
      :wrapper-closable="true"
    >
      <div class="remarks-history-drawer">
        <div class="history-timeline">
          <div v-for="(item, index) in storeRemarksHistory" :key="`${item.creationTime || ''}_${index}`" class="history-item">
            <div class="history-dot" :class="{ active: index === 0 }"></div>
            <div>
              <div class="history-meta">
                <span class="history-time">{{ item.creationTime | timeFilters }}</span>
                <el-tag v-if="index === 0" class="history-current-tag" size="mini">{{ $t('InternalSalesOrderDetails.Current') }}</el-tag>
              </div>
              <div class="history-remark">{{ item.remark }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

  <script>
  import html2canvas from 'html2canvas';
  import JsPDF from 'jspdf';
  import JsBarcode from 'jsbarcode';
  import JSZip from 'jszip';
  import { purchaseApi } from '@/api';
  import orderLog from '@/utils/log.js';
  import printJS from 'print-js';
  // 引入时间过滤组件
  import { timeFilters } from '@/filters';
  export default {
    props: {
        data: {
            type: Object,
            default: null,
        }
    },
    data(){
      return {
        selectedRows: [],
        customerRemarks: '',
        form: {
          customerRemarks: '',
        },
        isEdit: false,
        printList: [],
        historyVisible: false,
        storeRemarksHistory: [],
        fixingRecvQty: false,
      };
    },
    methods: {
      cloneRemarks(value) {
        this.customerRemarks = value.customerRemarks;
        this.getStoreRemarksHistory();
      },
      openEdit() {
        this.form.customerRemarks = this.customerRemarks;
        this.isEdit = true;
      },
      showHistory() {
        this.historyVisible = true;
      },
      getStoreRemarksHistory() {
        const id = this.$route.query.id;
        if (!id) {
          this.storeRemarksHistory = [];
          return;
        }
        purchaseApi.getStoreRemarks({ id }).then(res => {
          this.storeRemarksHistory = Array.isArray(res) ? res : [];
        });
      },
      editRemarks() {
        const params = {
          code: this.data.code,
          customerRemarks: this.form.customerRemarks
        };
        purchaseApi.editStoreRemarks(params).then(res => {
          this.customerRemarks = this.form.customerRemarks;
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.$parent.getData();
          this.getStoreRemarksHistory();
        }).finally(() => {
          this.isEdit = false;
        });
      },
      close() {
        this.isEdit = false;
        this.form.customerRemarks = '';
      },
      onConfirm(item){
        purchaseApi.goodsReceivedQuantityConfirm({
          ids: [{id: item.id}]
        }).then(()=>{
          this.$emit('refresh')
        })
      },
      onBatchconfirmation(){
        if (!this.selectedRows.length) return this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        this.$confirm(this.$t('confirmOperationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(() => {
          let ids = []
          this.selectedRows.forEach(item=>{
            ids.push({id: item.id})
          })
          purchaseApi.goodsReceivedQuantityConfirm({ids}).then(()=>{
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.$emit('refresh')
          })
        })
      },
      showLog() {
        orderLog(
          this.$BjDialogListConfig['purchaseDefault'](`${this.$t('BusinessPurchaseApplyDetail.dialogText2')}`, {
            defaultQuery: {
              recordId: this.$route.query.id,
            },
            columns: [
              {
                prop: 'creationDate',
                label: 'BjDialogListConfig.Operationtime',
              },
              {
                prop: 'operateName',
                label: 'BjDialogListConfig.Operator',
              },
              {
                prop: 'actionCode',
                label: 'BjDialogListConfig.Remarks',
              },
            ],
            search: [],
          }),
        );
      },
      handleClose() {
        this.$emit('close');
      },
      handleSelectionChange(val){
        this.selectedRows = val
      },
      generateBarcodeBlob(value, format = 'CODE128') {
        const canvas = document.createElement('canvas');
        canvas.width = 38;
        canvas.height = 25;
        JsBarcode(canvas, value, {
          format: format,
          lineColor: "#000",
          width: 5,
          height: 400,
          fontSize: 50,
          textMargin: 30,
          marginBottom: 50,
          marginLeft: 100,
          marginRight: 100,
          fontOptions: 'bold',
          displayValue: true
        });
        return new Promise((resolve) => {
          canvas.toBlob(blob => { resolve(blob) }, 'image/png');
        });
      },
      async onDownload() {
        if (!this.selectedRows.length) return this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(async () => {
          // let obj = { ids: []}
          // this.selectedRows.forEach(item=>{
          //   obj.ids.push({id: item.id})
          // })
          // purchaseApi.goodsDownloadBarcodeCheck(obj)
          const values = this.selectedRows.map(item=> item.barCode || item.skuCode)
          const regex = /^[!@#$%^&*()_+<>?":| {}\/\[\]\\\-+=,.\/;'*0-9A-Za-z]*$/;
          const barcode = values.filter(item => regex.test(item));
          const zip = new JSZip();
          for (let i = 0; i < barcode.length; i++) {
            const blob = await this.generateBarcodeBlob(barcode[i]);
            zip.file(`${barcode[i]}.png`, blob);
          }
          zip.generateAsync({ type: 'blob' })
            .then(function(content) {
              const url = window.URL.createObjectURL(content);
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'barcodes.zip');
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
          });
        })
      },
      exportPage(){
        html2canvas(this.$refs.pdfTempForm, {
            allowTaint: true,
            taintTest: false,
            useCORS: true,
            dpi: window.devicePixelRatio * 4,
            scale: 4,
            logging: true, // 日志开关，便于查看html2canvas的内部执行流程
        }).then((canvas) => {
            const url = canvas.toDataURL();
            printJS({
                printable: url, // 要打印的id
                type: 'image',
                style: '@page{size:auto;margin: 0cm 1cm 0cm 1cm;}' // 去除页眉页脚
            });
        });
      },
      exportList() {
        const printData = this.data.purchaseOrderGoods || [];
        const printStyle = '@page{size:A4 landscape;margin:6mm;}table{width:100%!important;table-layout:fixed;border-collapse:collapse;}th,td{padding:3px 2px!important;font-size:8px!important;line-height:1.2!important;text-align:center!important;word-break:break-word!important;white-space:normal!important;}th{font-size:9px!important;font-weight:600;}th:first-child,td:first-child{width:24px!important;max-width:24px!important;}';
        this.printList = printData.map((item, index) => ({
          ...item,
          index: index + 1,
          skuCode: item.skuCode || item.standardSkuCode || '',
          standardSkuCode: item.standardSkuCode || item.skuCode || '',
          planQty: item.planQty ?? '',
          pendingQty: item.pendingQty ?? '',
          stockedQty: item.stockedQty ?? '',
          qty: item.qty ?? '',
          needSerialNo: item.needSerialNo === 1 ? this.$t('yesText') : this.$t('noText'),
          isDownloadBarcode: item.isDownloadBarcode === 1 ? this.$t('yesText') : this.$t('noText'),
          expiryDate: item.expiryDate ? timeFilters(item.expiryDate) : '',
          checkStatus: {
            0: this.$t('BusinessPurchaseOrder3.Not'),
            1: this.$t('BusinessPurchaseOrder3.pass'),
            default: this.$t('BusinessPurchaseOrder3.Fail')
          }[item.checkStatus],
          isConfirm: item.isConfirm === 1 ? this.$t('ConfirmedText') : this.$t('UnconfirmedText'),
          volume: item.width && item.height && item.length ? `${(item.width * item.height * item.length / 1000000).toFixed(9)} m³` : undefined
        }));
        printJS(
          {
            printable: this.printList,
            gridHeaderStyle: 'border: 1px solid #303133;',
            gridStyle: 'text-align: center;border: 1px solid #303133;',
            style: printStyle,
            properties: this.$store.getters.cusId ? [
              { field: 'index', displayName: this.$t('billingPage.index') },
              { field: 'standardSkuCode', displayName: 'SKU' },
              { field: 'skuName', displayName: this.$t('BusinessPurchaseOrder2.form.skuName') },
              { field: 'planQty', displayName: this.$t('BusinessPurchaseOrder3.ExpectedQty') },
              { field: 'pendingQty', displayName: this.$t('BusinessPurchaseOrder3.PendingQty') },
              { field: 'stockedQty', displayName: this.$t('BusinessPurchaseOrder3.StockedQty') },
              { field: 'batchCode', displayName: this.$t('BusinessPurchaseOrder2.form.batchCode') },
              { field: 'needSerialNo', displayName: this.$t('goodsPage.Serial') },
              { field: 'expiryDate', displayName: this.$t('BusinessPurchaseOrder2.form.expiryDate') },
              { field: 'length', displayName: this.$t('BusinessPurchaseDetailPage.table.length') },
              { field: 'width', displayName: this.$t('BusinessPurchaseDetailPage.table.width') },
              { field: 'height', displayName: this.$t('BusinessPurchaseDetailPage.table.high') },
              { field: 'volume', displayName: this.$t('BusinessPurchaseDetailPage.table.Volume') },
              { field: 'weight', displayName: this.$t('BusinessPurchaseDetailPage.table.Weight') },
            ] : [
              { field: 'index', displayName: this.$t('billingPage.index') },
              { field: 'skuCode', displayName: 'SKU' },
              { field: 'skuName', displayName: this.$t('BusinessPurchaseOrder3.Product') },
              { field: 'planQty', displayName: this.$t('BusinessPurchaseOrder3.ExpectedQty') },
              { field: 'pendingQty', displayName: this.$t('BusinessPurchaseOrder3.PendingQty') },
              { field: 'stockedQty', displayName: this.$t('BusinessPurchaseOrder3.StockedQty') },
              { field: 'barCode', displayName: this.$t('BarcodeConfiguration.Barcode') },
              { field: 'expiryDate', displayName: this.$t('BusinessPurchaseOrder3.Expiry') },
              { field: 'qty', displayName: this.$t('goodsSku.detail.itemPerCarton') },
              { field: 'batchCode', displayName: this.$t('BusinessPurchaseOrder3.Batch') },
              { field: 'needSerialNo', displayName: this.$t('goodsPage.Serial') },
              { field: 'isDownloadBarcode', displayName: this.$t('BusinessPurchaseOrder3.Downloadstatus') },
              { field: 'checkStatus', displayName: this.$t('BusinessPurchaseOrder3.IsChecked') },
              { field: 'isConfirm', displayName: this.$t('BusinessPurchaseOrder3.IsConfirm') },
            ],
            type: 'json'
          }
        );
      },
      getPONo() {
        this.$emit('getPONo');
      },
      fixRecvQty() {
        this.fixingRecvQty = true;
        purchaseApi.allocatePurchaseOrderPendingPool({ poNum: this.data.code }).then(res => {
          if (!res?.failed) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.$emit('refresh');
          }
        }).finally(() => {
          this.fixingRecvQty = false;
        });
      }
    }
  };
  </script>

<style lang="scss" scoped>
.bj-form-item {
  font-size: 13px !important;
  color: #000;
  .bj-form-item-value {
    color: #000 !important;
  }
}
.el-table thead {
  color: #000 !important;
}
.no-rb {
  border-right: none !important;
}
.remark-actions {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-left: 8px;
}
.history-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.remarks-history-drawer {
  padding: 0 20px 24px;
}
.history-timeline {
  position: relative;
  padding-left: 28px;
}
.history-timeline::before {
  position: absolute;
  top: 4px;
  bottom: 8px;
  left: 5px;
  width: 1px;
  background: #d9e1ec;
  content: '';
}
.history-item {
  position: relative;
  margin-bottom: 24px;
}
.history-dot {
  position: absolute;
  top: 3px;
  left: -28px;
  width: 10px;
  height: 10px;
  border: 2px solid #b8c0cc;
  border-radius: 50%;
  background: #fff;
}
.history-dot.active {
  border-color: #409eff;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.16);
}
.history-current-tag {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.history-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.history-time {
  color: #909399;
  font-size: 12px;
}
.history-remark {
  line-height: 20px;
  white-space: pre-wrap;
  word-break: break-word;
}
::v-deep .el-table thead {
  .cell {
    margin-left: 4px !important;
  }
}
</style>
